import React, { Component } from 'react';
import { JSXLike } from '../../../../../models/Global';
import Switch from '../../../../../components/switch/Switch';
import * as Styles from './Styles';

type Props = {
	checked: boolean;
	onClick: () => void;
	description: JSXLike;
};

type State = {};

class ConsentRow extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.ConsentRowWrapper checked={this.props.checked}>
				<Switch
					isActive={this.props.checked}
					onClick={this.props.onClick}
				/>
				<p onClick={this.props.onClick}>{this.props.description}</p>
			</Styles.ConsentRowWrapper>
		);
	}
}

export default ConsentRow;
